<div class="modal-header">
  <h5 class="modal-title">Kết quả tra cứu mã số thuế</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <div class="container-fluid">

    <!-- Loading -->
    <div *ngIf="isChecking" class="text-center py-5">
      <div class="spinner-border text-primary mb-3" role="status"></div>
      <p class="mb-0">Đang tra cứu mã số thuế...</p>
    </div>

    <!-- Có kết quả -->
    <ng-container *ngIf="!isChecking && results.length > 0">
      <div class="alert alert-success">
        <h6 class="mb-3">
          <i class="bi bi-search me-2"></i>
          Tìm thấy <strong>{{ results.length }}</strong> kết quả phù hợp
        </h6>

        <div *ngFor="let item of results; let i = index" 
             class="card mb-3 shadow-sm">
          <div class="card-body">
            <h6 class="card-title text-primary mb-3">
              Kết quả #{{ i + 1 }}
            </h6>
            
            <table class="table table-borderless table-sm mb-0">
              <tr>
                <td width="160"><strong>Mã số thuế:</strong></td>
                <td>
                  <div class="tax-code-value">
                    <span>{{ item.taxCode }}</span>
                    <button *ngIf="item.taxCode" type="button"
                            class="tax-code-copy text-primary"
                            title="Sao chép mã số thuế" aria-label="Sao chép mã số thuế"
                            (click)="copyTaxCode(item.taxCode)">
                      <i class="ri-file-copy-line" aria-hidden="true"></i>
                    </button>
                  </div>
                </td>
              </tr>
              <tr>
                <td><strong>Tên doanh nghiệp:</strong></td>
                <td class="fw-bold">{{ item.companyName }}</td>
              </tr>
              <tr>
                <td><strong>Địa chỉ:</strong></td>
                <td>{{ item.address }}</td>
              </tr>
              <tr>
                <td><strong>Trạng thái:</strong></td>
                <td>
                  <span class="badge" 
                        [ngClass]="item.status === '00' ? 'bg-success' : 'bg-warning'">
                    {{ item.activeStatus }}
                  </span>
                </td>
              </tr>
              <tr>
                <td><strong>Chủ sở hữu:</strong></td>
                <td>{{ item.owner || '—' }}</td>
              </tr>
              <tr>
                <td><strong>Ngày sửa đổi:</strong></td>
                <td>{{ item.modifiedDate | date:'dd/MM/yyyy HH:mm' }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </ng-container>

    <div *ngIf="!isChecking && results.length === 0" 
         class="alert alert-danger text-center py-4">
      <i class="bi bi-x-circle-fill fs-1 mb-3 d-block"></i>
      <p class="mb-0">
        {{ result?.message || 'Không tìm thấy thông tin hoặc tra cứu thất bại!' }}
      </p>
    </div>

  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">Đóng</button>
</div>
